enum TypeDossierSale {
	NewBuildAppartments = "NewBuildAppartments",
	NewBuildHouseContractor = "NewBuildHouseContractor",
	PrivateIndividualsNewBuild = "PrivateIndividualsNewBuild",
	PrivateIndividualsRenovation = "PrivateIndividualsRenovation",
	Specials = "Specials",
	ServiceAppliances2People = "ServiceAppliances2People",
	ServiceAppliances1Person = "ServiceAppliances1Person",
	PickupShowroom = "PickupShowroom",
	SpecialistTrade = "SpecialistTrade"
}

export default TypeDossierSale;